import { Component, Input } from "@angular/core";

@Component({
    selector: "app-planung-taskcard-avatar",
    templateUrl: "./avatar.component.html",
    styleUrls: ["./avatar.component.scss"],
    standalone: false
})
export class PlanungApiTaskContactAvatarComponent {

    @Input() contact: {label?: string, email: string} = null;
    @Input() size: "small" | "normal" | "big" = "small";

    public GetAvatarInitials(label: string) {
        if (!label) {
          return "??";
        }
        const parts = label.split(" ").filter((x) => x && x.trim().length > 0);
        if (parts.length === 0) {
          return "??";
        }
        if (parts.length === 1) {
          return (
            parts[0][0].toUpperCase() +
            (parts[0].length === 1 ? "" : [parts[0][1].toUpperCase()])
          );
        }
        return parts[0][0].toUpperCase() + parts[1][0].toUpperCase();
      }
      public GetAvatarColor(label: string) {
        const colors = [
          "#00AA55",
          "#009FD4",
          "#B381B3",
          "#939393",
          "#E3BC00",
          "#D47500",
          "#DC2A2A",
        ];
        const charCodes = label
          .split("")
          .map((char) => char.charCodeAt(0))
          .join("");
        return colors[parseInt(charCodes, 10) % colors.length];
      }

}
